import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';
import { isUndefined } from 'lodash';

export const sensorAttributesApi = createApi({
  reducerPath: 'sensorAttributesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getSensorAttributes: builder.query({
      query: (sensorId) => ({
        url: urls.sensorsAttributes(sensorId),
      }),
    }),
    getOrderedAttributes: builder.query({
      query: () => ({
        url: urls.orderedSensorsAttributes,
      }),
    }),
    getSensorAttributeDetail: builder.query({
      query: ({ sensorId, attributeId }) => ({
        url: urls.sensorAttributesDetail(sensorId, attributeId),
      }),
    }),
    saveSensorAttribute: builder.mutation({
      query: ({ sensorId, attributeId, values }) => {
        if (isUndefined(attributeId)) {
          return {
            url: urls.sensorsAttributes(sensorId),
            method: 'POST',
            data: values,
          };
        }

        return {
          url: urls.sensorAttributesDetail(sensorId, attributeId),
          method: 'PATCH',
          data: values,
        };
      },
    }),
    deleteSensorAttribute: builder.mutation({
      query: ({ sensorId, attributeId }) => ({
        url: urls.sensorAttributesDetail(sensorId, attributeId),
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetSensorAttributesQuery,
  useGetOrderedAttributesQuery,
  useGetSensorAttributeDetailQuery,
  useSaveSensorAttributeMutation,
  useDeleteSensorAttributeMutation,
} = sensorAttributesApi;
